import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import useApp from '@/pages/App.context';
import Button from '@/components/Button';
import styles from '@/pages/Auth/Auth.module.scss';

const ResetPasswordSuccess = () => {
  const { t } = useTranslation(['auth']);
  const { setAppTitle } = useApp();

  useEffect(() => {
    setAppTitle(t('auth:reset.title'));
  }, [setAppTitle, t]);

  return (
    <>
      <h2 className={styles.heading}>{t('auth:reset.resultTitle')}</h2>
      <div className={styles.text}>{t('auth:reset.resultDesc')}</div>
      <Button
        as="link"
        className={classNames(styles.button, styles.code)}
        to="/auth/login"
      >
        {t('auth:login.title')}
      </Button>
    </>
  );
};

export default ResetPasswordSuccess;
